// ---------------------------------------------------------------------------
// STATISCHE CONTENT — pas hier je deals, blogs en affiliate-links aan.
// Geen server/database nodig: na 'yarn build' staat alles in de site.
// ---------------------------------------------------------------------------

// Affiliate-links: vervang de placeholder-URLs door je echte affiliate-links.
// Bijv. tix: "https://www.tix.nl/?affiliate=JOUW_CODE"
export const AFFILIATE_LINKS = {
  tix: "https://example.com",
  ticketmaster: "https://example.com",
  eventim: "https://example.com",
  booking: "https://example.com",
};

export const goUrl = (slug) => AFFILIATE_LINKS[slug] || "#";

const A = "✅ Nu verkrijgbaar";

// Alle deals. category: popular | concert | festival | flight | attraction
export const DEALS = [
  // Populaire deals (homepage)
  { id: "d1", category: "popular", event: "Lowlands 2026", location: "", date: "", price: "€229,99", provider: "Ticketmaster", provider_slug: "ticketmaster", availability: A, featured: true },
  { id: "d2", category: "popular", event: "Tomorrowland 2027", location: "", date: "", price: "€299,00", provider: "Eventim", provider_slug: "eventim", availability: A, featured: true },
  { id: "d3", category: "popular", event: "Vlucht Amsterdam → Barcelona", location: "", date: "", price: "€89,99", provider: "Tix.nl", provider_slug: "tix", availability: A, featured: true },
  // Concerten
  { id: "d4", category: "concert", event: "Armin van Buuren", location: "Amsterdam, Ziggo Dome", date: "15-11-2026", price: "€69,99", provider: "Ticketmaster", provider_slug: "ticketmaster", availability: A },
  { id: "d5", category: "concert", event: "Ed Sheeran", location: "Rotterdam, Ahoy", date: "20-11-2026", price: "€89,50", provider: "Eventim", provider_slug: "eventim", availability: A },
  { id: "d6", category: "concert", event: "Coldplay", location: "Eindhoven, Stadion", date: "12-12-2026", price: "€99,99", provider: "Ticketmaster", provider_slug: "ticketmaster", availability: A },
  // Festivals
  { id: "d7", category: "festival", event: "Lowlands 2026", location: "Biddinghuizen", date: "18-20 aug 2026", price: "€229,50", provider: "Ticketmaster", provider_slug: "ticketmaster", availability: A },
  { id: "d8", category: "festival", event: "Tomorrowland 2027", location: "Boom (BE)", date: "juli 2027", price: "€299,00", provider: "Eventim", provider_slug: "eventim", availability: A },
  { id: "d9", category: "festival", event: "Awakenings 2026", location: "Spaarnwoude", date: "juni 2026", price: "€179,00", provider: "Ticketmaster", provider_slug: "ticketmaster", availability: A },
  // Vliegtickets
  { id: "d10", category: "flight", event: "Amsterdam → Barcelona", location: "Vertrek: Schiphol", date: "Flexibel", price: "€89,99", provider: "Tix.nl", provider_slug: "tix", availability: A },
  { id: "d11", category: "flight", event: "Amsterdam → New York", location: "Vertrek: Schiphol", date: "Flexibel", price: "€399,00", provider: "Tix.nl", provider_slug: "tix", availability: A },
  { id: "d12", category: "flight", event: "Amsterdam → Londen", location: "Vertrek: Schiphol", date: "Flexibel", price: "€59,99", provider: "Tix.nl", provider_slug: "tix", availability: A },
  // Attracties
  { id: "d13", category: "attraction", event: "Disneyland Paris", location: "Parijs, Frankrijk", date: "Dagticket", price: "€89,00", provider: "Booking.com", provider_slug: "booking", availability: A },
  { id: "d14", category: "attraction", event: "Efteling", location: "Kaatsheuvel, NL", date: "Dagticket", price: "€44,00", provider: "Tix.nl", provider_slug: "tix", availability: A },
  { id: "d15", category: "attraction", event: "Walibi Holland", location: "Biddinghuizen, NL", date: "Dagticket", price: "€39,50", provider: "Tix.nl", provider_slug: "tix", availability: A },
];

export const getDeals = (category) =>
  category ? DEALS.filter((d) => d.category === category) : DEALS;

const CONCERT_IMG = "https://images.pexels.com/photos/761543/pexels-photo-761543.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const FESTIVAL_IMG = "https://images.pexels.com/photos/35593189/pexels-photo-35593189.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const FLIGHT_IMG = "https://images.pexels.com/photos/9129698/pexels-photo-9129698.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const BLOGS = [
  {
    slug: "hoe-koop-je-goedkope-concerttickets",
    title: "Hoe Koop Je Goedkope Concerttickets in 2026? – Compleet Gids",
    excerpt: "Bespaar tot 50% op concerttickets! Leer hoe je goedkope tickets koopt voor Armin van Buuren, Ed Sheeran, Coldplay en meer.",
    image: CONCERT_IMG,
    category: "Tickets",
    published_at: "2026-06-01",
    content: `
<p>Ben je op zoek naar <strong>goedkope concerttickets</strong> voor je favoriete artiest? In deze gids laten we je zien hoe je <strong>tot 50% kunt besparen</strong> op tickets voor concerten in Nederland en Belgie.</p>
<h2>🎟️ Waar Koop Je Goedkope Concerttickets?</h2>
<p>Er zijn verschillende websites waar je concerttickets kunt kopen. Hier zijn de beste opties:</p>
<ol>
  <li><strong>Ticketmaster</strong> – De grootste aanbieder van concerttickets in Nederland. <a href="/go/ticketmaster">Bekijk de beste deals hier</a>.</li>
  <li><strong>Eventim</strong> – Populair voor theaters en concerten. <a href="/go/eventim">Bekijk Eventim hier</a>.</li>
  <li><strong>Tix.nl</strong> – Ideaal voor vliegtickets en reispakketten. <a href="/go/tix">Bekijk Tix.nl hier</a>.</li>
</ol>
<h2>💰 5 Tips om Geld te Besparen op Concerttickets</h2>
<ol>
  <li><strong>Boek vroeg</strong> – Tickets zijn vaak het goedkoopst bij de voorverkoop.</li>
  <li><strong>Vergelijk prijzen</strong> – Gebruik Tixter.nl om prijzen van verschillende aanbieders te vergelijken.</li>
  <li><strong>Gebruik kortingscodes</strong> – Zoek op Google naar "[Artiest] kortingscode".</li>
  <li><strong>Koop last-minute</strong> – Soms zijn er nog tickets beschikbaar tegen gereduceerde prijzen.</li>
  <li><strong>Word lid van fanclubs</strong> – Veel artiesten bieden exclusieve kortingen voor fanclubleden.</li>
</ol>
<h2>❓ Veelgestelde Vragen</h2>
<h3>Waar kan ik veilig concerttickets kopen?</h3>
<p>Koop altijd bij <strong>officiele aanbieders</strong> zoals Ticketmaster, Eventim of Tix.nl. Vermijd onbekende websites om fraude te voorkomen.</p>
<h3>Hoe weet ik of een ticket legitiem is?</h3>
<p>Controleer of de website een <strong>SSL-certificaat</strong> heeft (https://) en lees reviews van andere klanten.</p>
<p><strong>🔥 Bespaar nu!</strong> Bekijk de beste concertticket deals op <a href="/concerttickets">Tixter.nl/Concerttickets</a>.</p>
`,
  },
  {
    slug: "lowlands-2026-tickets",
    title: "Lowlands 2026 Tickets – Alles Wat Je Moet Weten",
    excerpt: "Alles over Lowlands 2026 tickets: prijzen, datums, waar kopen en tips. Bespaar nu op je festivalticket!",
    image: FESTIVAL_IMG,
    category: "Festivals",
    published_at: "2026-05-20",
    content: `
<p>Lowlands is een van de <strong>grootste en meest geliefde festivals</strong> in Nederland. In 2026 vindt het plaats van <strong>18 tot en met 20 augustus</strong> in Biddinghuizen. Ben je van plan om te gaan? Hier is alles wat je moet weten over <strong>Lowlands 2026 tickets</strong>!</p>
<h2>📅 Wanneer Ga Je Lowlands 2026 Tickets Kopen?</h2>
<p>De voorverkoop voor Lowlands 2026 start naar verwachting in <strong>februari 2026</strong>. Houd de officiele <a href="https://lowlands.nl" target="_blank" rel="noopener">Lowlands website</a> in de gaten voor de exacte datum.</p>
<p><strong>Tip:</strong> Zet een herinnering in je agenda, want de tickets zijn vaak <strong>binnen enkele uren uitverkocht</strong>!</p>
<h2>💰 Hoeveel Kost een Lowlands 2026 Ticket?</h2>
<p>De prijzen voor Lowlands 2026 zijn nog niet bekend, maar in 2025 kostte een <strong>3-daags ticket</strong> ongeveer <strong>€229,50</strong> (excl. servicekosten). Verwacht een vergelijkbare prijs in 2026.</p>
<ul>
  <li><strong>Comfort tickets</strong> (met extra voorzieningen) – ~€275</li>
  <li><strong>Camping tickets</strong> (voor wie wil kamperen) – ~€50 extra</li>
  <li><strong>Glamping</strong> (luxere accommodatie) – ~€300+</li>
</ul>
<h2>🎟️ Waar Koop Je Lowlands 2026 Tickets?</h2>
<ol>
  <li><strong>Officiele Lowlands website</strong> – <a href="https://lowlands.nl" target="_blank" rel="noopener">lowlands.nl</a></li>
  <li><strong>Ticketmaster</strong> – <a href="/go/ticketmaster">Bekijk hier</a></li>
</ol>
<p><strong>⚠️ Waarschuwing:</strong> Koop <strong>nooit</strong> tickets via onofficiele websites zoals Marktplaats of Facebook. Dit zijn vaak <strong>nep-tickets</strong>!</p>
<h2>❓ Veelgestelde Vragen over Lowlands 2026</h2>
<h3>Kan ik mijn Lowlands ticket annuleren?</h3>
<p>Nee, Lowlands tickets zijn <strong>niet annuleerbaar</strong>. Zorg er dus voor dat je zeker weet dat je kunt gaan voordat je boekt.</p>
<p><strong>🔥 Bespaar op Lowlands Tickets!</strong> Bekijk de beste deals op <a href="/festivaltickets">Tixter.nl/Festivaltickets</a>.</p>
`,
  },
  {
    slug: "goedkope-vliegtickets-boeken",
    title: "Goedkope Vliegtickets Boeken – 10 Tips om Geld te Besparen",
    excerpt: "Bespaar honderden euro's op vliegtickets! Leer 10 tips om de goedkoopste vluchten te vinden en boeken.",
    image: FLIGHT_IMG,
    category: "Vliegtickets",
    published_at: "2026-05-05",
    content: `
<p>Het boeken van <strong>goedkope vliegtickets</strong> kan een uitdaging zijn, maar met de juiste tips kun je <strong>honderden euro's besparen</strong> op je volgende reis. In deze gids delen we <strong>10 bewezen tips</strong> om de beste deals te vinden.</p>
<h2>💰 10 Tips voor Goedkope Vliegtickets</h2>
<h3>1. Boek op het Juiste Moment</h3>
<p>De beste tijd om vliegtickets te boeken is <strong>6-8 weken voor vertrek</strong> voor binnen-Europese vluchten en <strong>3-5 maanden voor intercontinentale vluchten</strong>.</p>
<h3>2. Vlieg op Onpopulaire Dagen</h3>
<p>Vluchten op <strong>dinsdag, woensdag en zaterdag</strong> zijn vaak goedkoper dan op vrijdag of zondag.</p>
<h3>3. Gebruik Incognito Modus</h3>
<p>Sommige websites verhogen de prijzen als ze zien dat je vaker zoekt. Gebruik <strong>incognito modus</strong> om dit te voorkomen.</p>
<h3>4. Boek een Retourticket</h3>
<p>Een <strong>retourticket</strong> is vaak goedkoper dan twee losse enkele tickets.</p>
<h3>5. Gebruik een Vergelijkingswebsite</h3>
<p>Websites zoals <a href="/go/tix">Tix.nl</a>, Skyscanner en Kayak vergelijken prijzen van verschillende luchtvaartmaatschappijen.</p>
<h3>6. Boek via een Reisbureau</h3>
<p>Soms bieden reisbureaus zoals <a href="/go/tix">Tix.nl</a> <strong>exclusieve deals</strong> die je nergens anders vindt.</p>
<h3>7. Wees Flexibel met Bestemmingen</h3>
<p>Gebruik de "Overal naartoe" optie om de <strong>goedkoopste bestemmingen</strong> te vinden.</p>
<h2>❓ Veelgestelde Vragen</h2>
<h3>Wat is het beste moment om een vliegticket te boeken?</h3>
<p>Voor <strong>binnen-Europese vluchten</strong>: 6-8 weken voor vertrek. Voor <strong>intercontinentale vluchten</strong>: 3-5 maanden voor vertrek.</p>
<p><strong>🔥 Bespaar nu op vliegtickets!</strong> Bekijk de beste deals op <a href="/vliegtickets">Tixter.nl/Vliegtickets</a>.</p>
`,
  },
];

export const getBlog = (slug) => BLOGS.find((b) => b.slug === slug);
